import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCartItems } from '../../actions/cartAction';
import MetaData from '../Layouts/MetaData';
import CartItem from './CartItem';
import EmptyCart from './EmptyCart';
import PriceSidebar from './PriceSidebar';
import SaveForLaterItem from './SaveForLaterItem';
import { Box, Button, Container, Grid, Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Cart = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();
    const { cartItems } = useSelector((state) => state.cart);
    const { saveForLaterItems } = useSelector((state) => state.saveForLater);

    useEffect(() => {
        dispatch(getCartItems());
    }, [dispatch]);

    const placeOrderHandler = () => {
        navigate('/login?redirect=shipping');
    }

    return (
        <>
            <MetaData title="Shopping Cart | Flipkart" />
            <Container maxWidth="xl" sx={{ mt: 12, mb: 4 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Paper elevation={3} sx={{ p: 3, mb: 4, bgcolor: 'background.paper' }}>
                            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                                My Cart ({cartItems.length})
                            </Typography>
                            {cartItems && cartItems.length === 0 && (
                                <EmptyCart />
                            )}
                            {cartItems && cartItems.map((item) => (
                                <CartItem key={item.product} {...item} inCart={true} />
                            ))}
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                                <Button 
                                    variant="contained" 
                                    onClick={placeOrderHandler} 
                                    disabled={cartItems.length < 1}
                                    sx={{ 
                                        bgcolor: theme.palette.warning.main, 
                                        '&:hover': { bgcolor: theme.palette.warning.dark },
                                        color: 'white',
                                        px: 6,
                                        py: 1.5
                                    }}
                                >
                                    Place Order
                                </Button>
                            </Box>
                        </Paper>

                        <Paper elevation={3} sx={{ p: 3, bgcolor: 'background.paper' }}>
                            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                                Saved For Later ({saveForLaterItems.length})
                            </Typography>
                            {saveForLaterItems && saveForLaterItems.map((item) => (
                                <SaveForLaterItem key={item.product} {...item} />
                            ))}
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <PriceSidebar cartItems={cartItems} showDeliveryCharge={true} />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};

export default Cart;